import CustomTextField from '@/components/CustomTextField/CustomTextField';
import { usePaymentSession } from '@/hooks/payment/usePaymentSession';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

type PartialPaymentProps = {
  handlePartialPaymentAmountChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  partialPaymentError: string | null;
  onEnter: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const PartialPayment = ({ handlePartialPaymentAmountChange, partialPaymentError, onEnter }: PartialPaymentProps) => {
  const { t } = useTranslation();
  const { partialPayment } = usePaymentSession();
  const textFieldRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (textFieldRef.current && partialPayment.enabled) {
      textFieldRef.current.focus();
    }
  }, [partialPayment.enabled]);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'hidden',
        height: {
          xs: partialPayment.enabled ? '130px' : '0px',
          sm: partialPayment.enabled ? '110px' : '0px'
        },
        marginTop: partialPayment.enabled ? '16px' : '0px',
        transition: 'height 0.3s ease-out, margin-top 0.3s ease-out'
      }}
    >
      <CustomTextField
        type='text'
        variant='outlined'
        placeholder={t('page.pay.other-amount-placeholder')}
        value={partialPayment.amount}
        onChange={handlePartialPaymentAmountChange}
        onKeyDown={onEnter}
        error={!!partialPaymentError}
        helperText={partialPaymentError}
        inputRef={textFieldRef}
        sx={{
          width: '100%'
        }}
        formHelperSx={{ textAlign: 'center' }}
        slotProps={{
          htmlInput: {
            inputMode: 'decimal',
            pattern: '[0-9,]*'
          },
          input: {
            endAdornment: <InputAdornment position='end'>{t('common-phrases.current-locale-currency')}</InputAdornment>
          }
        }}
      />
    </Box>
  );
};

export default PartialPayment;
